import { render, staticRenderFns } from "./headerName.vue?vue&type=template&id=58499389&scoped=true"
import script from "./headerName.vue?vue&type=script&lang=js"
export * from "./headerName.vue?vue&type=script&lang=js"
import style0 from "./headerName.vue?vue&type=style&index=0&id=58499389&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58499389",
  null
  
)

export default component.exports